import { createApi } from '@stilingue/st-auth-utils';
import { error401Handler } from '@/utils/error';
import Service from './Service';

const gateway = process.env.VUE_APP_SERVICES_PROXY_URL || '';

const afterParser = (response) => {
  return response.data;
};

class SacReportsService extends Service {
  constructor(gateway) {
    const api = createApi('/sac-reports', gateway, {
      authNotFound: () => true,
      error401Handler,
    });
    super(api, { afterParser });
  }

  replierByChannel(params = {}) {
    return this.find({
      ...params,
      url: '/charts/replier-by-channel',
    });
  }
}

export default new SacReportsService(gateway);
